<!--
    Summary:
        hkml.exhibition.web - p6-n-prenata-test-compare
    ChangeLog:
        wangn on 2020/11/28 added
-->
<template>
  <div class="v-p6-n-prenata-test-compare" title="p6-n-prenata-test-compare">
    <div class="header">
      <h2>{{$t('NPrenatalTest.p6_title')}}</h2>
    </div>
    <div class="content">
      <p>
        {{$t('NPrenatalTest.p6_content')}}
      </p>
      <img v-if="lang == 'en-US'" class="table-img" src="../../../assets/images/projects/n-prenata-test/table-en.png">
      <img v-else class="table-img" src="../../../assets/images/projects/n-prenata-test/table.png">
    </div>
  </div>
</template>

<script>
  export default {
    name: "p6-n-prenata-test-compare",
    computed: {
      lang: function () {
        let lang = this.$i18n.locale;
        return lang;
      }
    },
  }
</script>

<style scoped lang="scss">
  .v-p6-n-prenata-test-compare {

    text-align: center;
    padding: 1.5vw 0 3.5vw 0;

    .header {
      margin-bottom: 3.5vw;

      h2 {
        color: #273a63;
        font-size: 2.66vw;
        font-weight: bold;
      }
    }

    .content {
      p {
        text-align: left;
        margin: 0 12.7vw 4.5vw 13.3vw;
      }
      .table-img{
        width: 74.48vw;
        height: 39.38vw;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/projects/n-prenata-test/p6-n-prenata-test-compare.vue